import React from 'react';
import { Link } from "react-router-dom";
import {shareExperiment, listSharedRecords} from '../services/SharedExperimentService';
import SharedToUserRow from "./components/SharedToUserRow"

class ShareExperiment extends React.Component {
    constructor(props) {
        super(props);
        var baseUrl = window.location.href;
        this.state = {
           id: baseUrl.substring(baseUrl.lastIndexOf('/') + 1),
           jwtToken: props.jwtToken,
           userMail: "",
           rights: "VIEW",
           data: []
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.updateData = this.updateData.bind(this);
    }

    componentDidMount() {
        this.updateData();
    }

    updateData(){
        this.setState({data: []});
        listSharedRecords(this.state.jwtToken, this.state.id)
            .then(response =>
                {
                    this.setState({data: response});
                }
            );
    }

    handleInputChange = (e) => {
        if (e.target.name === "userMail") {
            this.setState({ userMail: e.target.value});
        }
        else if (e.target.name === "rights") {
            this.setState({ rights: e.target.value});
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.rights === "OWNER"
               && !window.confirm('Are you sure you want to transfer ownership of this experiment?\nThe experiment will be no longer accessible.')){
            return;
        }
        shareExperiment(this.state.jwtToken, this.state.id, this.state.userMail, this.state.rights)
        .then(response =>
            {
                if (response.ok){
                    if (this.state.rights === "OWNER"){
                        alert("Ownership transferred, redirecting to main page.");
                        window.location.pathname = "/";
                    } else {
                        alert("New user right has been added");
                        this.updateData();
                    }
                }
                else {
                    alert("Changes could not be saved");
                }
            }
        );
    };

    render() {
    var renderedRows = [];
    if (typeof this.state.data.userRights !== "undefined") {
        for (var i = 0; i < this.state.data.userRights.length; i++) {
            renderedRows.push(<SharedToUserRow key={i}
                id={this.state.data.userRights[i].id}
                email={this.state.data.userRights[i].targetUserMail}
                rights={this.state.data.userRights[i].rights}
                handler={this.updateData}
                jwtToken={this.state.jwtToken}
                />
            );
        }
    }

    return (
    <>
        <div className="row" style={{marginLeft: "4%", marginRight: "4%"}}>
            <h1>
                <Link to="/">
                    <span title="Return to experiment listing">All experiments/</span>
                </Link>
                { (typeof this.state.data.shared !== "undefined" && this.state.data.shared) ?
                    <Link to="/shared">
                        <span title="Return to shared experiment listing">shared/</span>
                    </Link> : <></>
                }
                Share to user/{this.state.data.name}
            </h1>
            <form style={{width: "550px", paddingTop:"10px", paddingBottom: "20px"}}>
                <div className="form-group">
                    <label>Share to</label>
                    <input className="form-control" type="text" name="userMail" placeholder="userMail@example.com"
                        onChange={(e) => this.handleInputChange(e)} />
                </div>
                <div className="form-group">
                    <label>Rights</label>
                    <select className="form-control" name="rights"
                        onChange={(e) => this.handleInputChange(e)} >
                            <option value="VIEW">View allowed</option>
                            <option value="EDIT">View and edit allowed</option>
                            <option value="SHARE">View, edit and sharing allowed</option>
                            <option value="OWNER">Transfer ownership to user</option>
                    </select>
                </div>
                <button type="submit" className="btn btn-primary" onClick={this.handleSubmit} >
                    Share experiment
                </button>
            </form>

            <h2>Shared to users</h2>
            <div style={{width: "60%"}}>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th style={{width: "300px"}}>Email</th>
                            <th>Rights</th>
                            <th style={{width: "70px"}}>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderedRows}
                    </tbody>
                </table>
            </div>

        </div>
    </>
    );
    }
}

export default ShareExperiment;
